import axiosInstance from '../../utils/setupAxios';
import {
  FETCH_LOGS_REQUEST,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAILURE,
  FETCH_LOGS_DATE_CHART_REQUEST,
  FETCH_LOGS_DATE_CHART_SUCCESS,
  FETCH_LOGS_DATE_CHART_FAILURE,
  FETCH_LOGS_TYPE_CHART_REQUEST,
  FETCH_LOGS_TYPE_CHART_SUCCESS,
  FETCH_LOGS_TYPE_CHART_FAILURE,
  FETCH_LOGS_FILTER_REQUEST,
  FETCH_LOGS_FILTER_SUCCESS,
  FETCH_LOGS_FILTER_FAILURE
} from '../types/logTypes';

export const fetchLogs = (pageOrParams = 1, itemsPerPage = 10) => async (dispatch) => {
  const params = typeof pageOrParams === 'object'
    ? pageOrParams
    : { page: pageOrParams, items_per_page: itemsPerPage };

  dispatch({ type: FETCH_LOGS_REQUEST });
  try {
    const {
      page = 1,
      items_per_page = 10,
      q,
      device,
      os_version,
      app_version,
      country_code,
      reason,
    } = params;
    const query = { page, items_per_page };
    if (q) query.q = q;
    if (device) {
      query.device = device;
      query.device_name = device;
    }
    if (os_version) query.os_version = os_version;
    if (app_version) query.app_version = app_version;
    if (country_code) query.country_code = country_code;
    if (reason) {
      query.reason = reason;
      query.error_code = reason;
    }
    const res = await axiosInstance.get('/songs/logs/get', { params: query });
    dispatch({ type: FETCH_LOGS_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_FAILURE, error });
  }
};

export const fetchLogsFilter = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_FILTER_REQUEST });
  try {
    const res = await axiosInstance.get('/songs/logs/get-filter', {
      params: { rich: 1 },
    });
    dispatch({ type: FETCH_LOGS_FILTER_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_FILTER_FAILURE, error });
  }
};

export const fetchLogsDateChart = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_DATE_CHART_REQUEST });
  try {
    const res = await axiosInstance.get('/songs/logs/get-chart');
    dispatch({ type: FETCH_LOGS_DATE_CHART_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_DATE_CHART_FAILURE, error });
  }
};

export const fetchLogsTypeChart = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_TYPE_CHART_REQUEST });
  try {
    const res = await axiosInstance.get('/songs/logs/get-bar-chart');
    dispatch({ type: FETCH_LOGS_TYPE_CHART_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_TYPE_CHART_FAILURE, error });
  }
}; 